(ns iris.posts.views.moderator-bar
  (:require
   [re-frame.core :as re-frame]
   [iris.posts.events :as posts-events]
   [iris.posts.subs :as posts-subs]))


(defn status-icon [status]
  (cond (= status "P") [:i.glyphicon.glyphicon-ok-circle]
        (= status "S") [:i.glyphicon.glyphicon-upload]
        (= status "Q") [:i.glyphicon.glyphicon-minus-sign]
        (= status "R") [:i.glyphicon.glyphicon-remove-circle]
        (= status "T") [:i.glyphicon.glyphicon-remove-sign]))

(defn status-color [status]
  (cond (= status "P") "text-success"
        (= status "S") "text-primary"
        (= status "Q") "text-warning"
        (= status "R") "text-danger"
        (= status "T") "text-secondary"))

(defn flag-color [screen-flag-level]
  (cond (= screen-flag-level 1) "text-success"
        (= screen-flag-level 2) "text-warning"
        (= screen-flag-level 3) "text-danger"
        (= screen-flag-level 4) "text-dark"))


(defn on-post-remove [e id]
  (.preventDefault e)
  (re-frame/dispatch [::posts-events/http-post-remove id]))

(defn on-post-approve [e id]
  (.preventDefault e)
  (re-frame/dispatch [::posts-events/http-post-approve id]))

(defn on-post-hide [e id]
  (.preventDefault e)
  (re-frame/dispatch [::posts-events/http-post-hide id]))

(defn on-post-unhide [e id]
  (.preventDefault e)
  (re-frame/dispatch [::posts-events/http-post-unhide id]))

(defn on-enable-replying [e id]
  (.preventDefault e)
  (re-frame/dispatch [::posts-events/http-post-enable-replying id]))

(defn on-disable-replying [e id]
  (.preventDefault e)
  (re-frame/dispatch [::posts-events/http-post-disable-replying id]))

(defn on-qc-pass [e id]
  (.preventDefault e)
  (re-frame/dispatch [::posts-events/http-post-qc-pass id]))

(defn on-qc-fail [e id]
  (.preventDefault e)
  (re-frame/dispatch [::posts-events/http-post-qc-fail id]))

(defn on-publish [e id]
  (.preventDefault e)
  (re-frame/dispatch [::posts-events/http-post-publish id]))




(defn remove-btn [id]
  [:a.btn.btn-grey-click.btn-disabled-click.btn-danger
   {:title "Remove"
    :on-click (fn [e] (on-post-remove e id))}
   [:i.glyphicon.glyphicon-remove]])

(defn approve-btn [id]
  [:a.btn.btn-grey-click.btn-disabled-click.btn-success
   {:title "Approve"
    :on-click (fn [e] (on-post-approve e id))}
   [:i.glyphicon.glyphicon-ok]])

(defn hide-btn [id]
  [:a.btn.btn-grey-click.btn-disabled-click.btn-danger
   {:title "Post not hidden. Click to hide"
    :on-click (fn [e] (on-post-hide e id))}
   [:i.glyphicon.glyphicon-eye-close]])

(defn unhide-btn [id]
  [:a.btn.btn-grey-click.btn-disabled-click.btn-success
   {:title "Post hidden. Click to unhide"
    :on-click (fn [e] (on-post-unhide e id))}
   [:i.glyphicon.glyphicon-eye-open]])

(defn enable-replying-btn [id]
  [:a.btn.btn-grey-click.btn-disabled-click.btn-success
   {:title "Unlock thread for posting"
    :on-click (fn [e] (on-enable-replying e id))}
   [:i.glyphicon.glyphicon-play]])

(defn disable-replying-btn [id]
  [:a.btn.btn-grey-click.btn-disabled-click.btn-danger
   {:title "Lock thread for posting"
    :on-click (fn [e] (on-disable-replying e id))}
   [:i.glyphicon.glyphicon-pause]])

(defn qc-pass-btn [id]
  [:a.btn.btn-default.qc-not-checked-btn
   {:title "QC not checked. Click to mark as QC pass"
    :on-click (fn [e] (on-qc-pass e id))}
   [:span.text-warning [:i.glyphicon.glyphicon-unchecked]]])

(defn qc-fail-btn [id]
  [:a.btn.btn-default.qc-not-checked-btn
   {:title "QC not checked. Click to mark as QC fail"
    :on-click (fn [e] (on-qc-fail e id))}
   [:span.text-warning [:i.glyphicon.glyphicon-unchecked]]])

(defn qc-checked [qc-by status]
  [:span.btn.btn-default.disabled
   {:style {:pointer-events "auto"}
    :title (str (cond (= status "P") "Approved"
                      (= status "R") "Removed")
                " by " qc-by)}
   [:span {:class (cond (= status "P") "text-success"
                        (= status "R") "text-danger")}
    [:i.glyphicon.glyphicon-check]]])

(defn publish-btn [id]
  [:a.btn.btn-default
   {:title "Process"
    :on-click (fn [e] (on-publish e id))}
   [:i.glyphicon.glyphicon-file]])


(defn status-btn [id status screen-notes]
  [:a.btn.btn-default
   {:title (str "Status: " status (when (and (= status "Q") (not-empty screen-notes)) (str "; Screen notes: " screen-notes))) ;; we actually need full status string, this is just first letter
    :style {:font-family "Arial" :font-weight "bold"}
    :href (str "/logs/p/" id)}
   [:span {:class (status-color status)} (str status " ") [status-icon status]]])

;; (defn flag-btn [screen-flag screen-flag-level screen-notes]
;;   (if (true? screen-flag)
;;     [:div.btn.btn-default
;;      {:style {:cursor "auto"}
;;       :title (str "Flag level: " screen-flag-level "; Screen notes: " screen-notes)}
;;      [:i.glyphicon.glyphicon-flag {:class (flag-color screen-flag-level)}]]
;;     [:div.btn.btn-default {:style {:cursor "auto"}} "\n\t\t\n\t\t \n\t\t\n\t"]))
(defn flag-btn [screen-flag screen-flag-level screen-notes]
  (when (true? screen-flag)
    [:div.btn.btn-default
     {:style {:cursor "auto"}
      :title (str "Flag level: " screen-flag-level "; Screen notes: " screen-notes)}
     [:i.glyphicon.glyphicon-flag {:class (flag-color screen-flag-level)}]]))

(defn op-btns [d roles]
  ;; (let [mod-logs @(re-frame/subscribe [::posts-subs/all-moderation-log (:id d)])
  ;;       mod-logs-desc (sort-by :datetime #(compare %2 %1) mod-logs)
  ;;       mod-logs-latest (first mod-logs-desc)]
    [:div.btn-group.btn-group-sm.moderator-bar
     {:role "group"}
     [status-btn (:id d) (:status d) (:screen_notes d)]
     (when (contains? roles "moderator")
       [:<>
        (if
        ;;  (true? (:hidden d))
         (true? (:isHidden d))
          [unhide-btn (:id d)]
          [hide-btn (:id d)])
        (if
        ;;  (true? (:replying_disabled d))
         (true? (:isLocked d))
          [enable-replying-btn (:id d)]
          [disable-replying-btn (:id d)])
        [publish-btn (:id d)]
        [flag-btn (:screen_flag d) (:screen_flag_level d) (:screen_notes d)]
        (if
        ;;  (true? (:qc d))
         (true? (:isQc d))
          [qc-checked (:qc_by d) (:status d)]
          (if (= (:status d) "P")
            [qc-pass-btn (:id d)]
            [qc-fail-btn (:id d)]))
        (if (or (= (:status d) "R") (= (:status d) "Q"))
          [approve-btn (:id d)]
          [remove-btn (:id d)])])]
    ;; )
  )


(defn reply-btns [d roles]
  [:div.btn-group.btn-group-sm.moderator-bar
   {:role "group"}
   [status-btn (:id d) (:status d) (:screen_notes d)]
   (when (contains? roles "moderator")
     [:<>
      (when (> (get-in d [:counts :tags]) 0)
        (if (true? (:isHidden d))
          [unhide-btn (:id d)]
          [hide-btn (:id d)]))
      [publish-btn (:id d)]
      [flag-btn (:screen_flag d) (:screen_flag_level d) (:screen_notes d)]
      (if
      ;;  (true? (:qc d))
       (true? (:isQc d))
        [qc-checked (:qc_by d) (:status d)]
        (if (= (:status d) "P")
          [qc-pass-btn (:id d)]
          [qc-fail-btn (:id d)]))
      (if (or (= (:status d) "R") (= (:status d) "Q"))
        [approve-btn (:id d)]
        [remove-btn (:id d)])])]
  )